import React from 'react';
import ScheduleWarningText from '../atoms/ScheduleWarningText';
import { IconType } from '@routific/hive';
import { StyledMessageBody, StyledMessageIcon } from '../styles/MessageStyles';

interface InvalidStopsWarningMessageProps {
  message: string;
  reason: string;
}

const InvalidStopsWarningMessage: React.FC<InvalidStopsWarningMessageProps> = ({ message, reason }) => (
  <StyledMessageBody>
    <StyledMessageIcon
      icon={IconType.Error}
      type="error"
    />
    <ScheduleWarningText color="red">{message}</ScheduleWarningText>
    <ScheduleWarningText>{reason}</ScheduleWarningText>
  </StyledMessageBody>
);

export default InvalidStopsWarningMessage;
